import { axiosInstanceNoAuth } from "@/helper/axios-instance";
import { DataAwareResponse, OrganizationPublicConfig } from "@/types/types";

/**
 * Fetch public organization configuration for the current domain
 * This is called on app startup to get domain-specific settings
 */
export const fetchDomainConfig = async (): Promise<DataAwareResponse<OrganizationPublicConfig>> => {
  try {
    const response =
      await axiosInstanceNoAuth.get<DataAwareResponse<OrganizationPublicConfig>>("/domain/config");

    return response.data;
  } catch (error) {
    console.error("Failed to fetch domain configuration:", error);
    throw error;
  }
};

/**
 * Check if current domain is configured
 */
export const checkDomainHealth = async (): Promise<boolean> => {
  try {
    const response = await axiosInstanceNoAuth.get("/domain/health");
    return response.data?.data?.isConfigured === true;
  } catch (error) {
    console.error("Domain health check failed:", error);
    throw error;
  }
};
